import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function packages() {
    return {
        search
    };

    function search(options = {}) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`document/search${params}`);
    }
}
